/* eslint-disable import/first */
// ResizeObserver 의 무해한 알림(「loop completed with undelivered notifications」)이 개발 서버의 오류 덮개로 뜨지 않게 한다.
// **capture 단계**로 건다 — 덮개(webpack-dev-server)의 리스너가 먼저 등록돼 있어, 예전처럼 bubble 로 걸면 덮개가 먼저 받아 띄운 뒤였다.
// App 안에도 같은 차단이 있지만 그것은 App 이 마운트된 뒤에만 선다(로그인 화면·초기 로딩 중에는 없다) — 그래서 맨 처음에 여기서 건다.
// 이미 뜬 덮개도 닫는다(신고 2026-10-12: 창을 여럿 띄운 상태에서 덮개가 화면을 가렸다).
const isBenignResizeError = (msg) => /ResizeObserver loop (completed with undelivered notifications|limit exceeded)/.test(String(msg || ''));
const closeDevOverlay = () => {
  document.querySelectorAll('#webpack-dev-server-client-overlay').forEach((el) => { try { el.remove(); } catch (_e) { /* 이미 없다 */ } });
};
window.addEventListener('error', (e) => {
  if (isBenignResizeError(e && e.message)) {
    e.stopImmediatePropagation();
    e.preventDefault();
    setTimeout(closeDevOverlay, 0);
  }
}, true);
window.addEventListener('unhandledrejection', (e) => {
  const r = e && e.reason;
  if (isBenignResizeError((r && r.message) || r)) {
    e.stopImmediatePropagation();
    e.preventDefault();
    setTimeout(closeDevOverlay, 0);
  }
}, true);

import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
// i18n 은 App 보다 먼저 초기화되어야 한다 — 컴포넌트가 첫 렌더에서 t() 를 부른다.
import './i18n';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import store, { persistor } from './redux/store';
import { ConfirmProvider } from './components/ConfirmDialog';
import { PromptProvider } from './components/PromptDialog';
import ErrorBoundary from './components/ErrorBoundary';
import { FeedbackProvider } from './components/FeedbackDialog';
import { WorkspaceDockProvider } from './components/workspace/WorkspaceDock';
import { installGlobalErrorLogging } from './services/opsLog';

// 창 전체의 오류를 기록에 잇는다. **여기서 한 번만** 부른다 — App.js 의 억제기(캡처 단계,
// 나중에 등록)보다 먼저 돌아야 잡음 판단을 우리 목록으로 할 수 있다.
installGlobalErrorLogging();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={<div>Loading...</div>} persistor={persistor}>
        <ConfirmProvider>
          <PromptProvider>
            {/*
              컴포넌트가 렌더 중 터지면 React 는 화면을 통째로 비운다 — 사용자는 새로고침 말고
              할 것이 없고 기록도 안 남았다. 안내와 버튼을 보여 주고 기록한다.
            */}
            {/* 문제 신고 — 에러 경계 **바깥**에 둔다. 화면이 깨진 뒤에도 신고 창은 떠야 한다 */}
            <FeedbackProvider>
              <ErrorBoundary>
                {/* 작업 탭(편집기 자리를 함께 쓰는 화면들) — 창(useModalWindow)과 App 이 함께 본다 */}
                <WorkspaceDockProvider>
                  <App />
                </WorkspaceDockProvider>
              </ErrorBoundary>
            </FeedbackProvider>
          </PromptProvider>
        </ConfirmProvider>
      </PersistGate>
    </Provider>
  </React.StrictMode>
);

reportWebVitals();
